import React from 'react';
import { Typography } from '@mui/material';
import { colors } from 'theme/colors';
import { StyledWrapper } from './styles';

export enum EChipsVariants {
  primary = 'primary',
  success = 'success',
  success100 = 'success100',
  warning = 'warning',
  error = 'error',
  oneSign = 'oneSign',
}

export interface IChips {
  text: string | undefined;
  variant?: EChipsVariants;
}

export const Chips = ({ text, variant = EChipsVariants.success }: IChips) => {
  let backgroundColor: string;
  let textColor: string;
  let lineHeight: string = '14px';
  switch (variant) {
    case EChipsVariants.primary:
      textColor = colors.primary700;
      backgroundColor = colors.primary50;
      break;
    case EChipsVariants.oneSign:
      textColor = colors.white;
      backgroundColor = colors.primary400;
      lineHeight = '22px';
      break;
    case EChipsVariants.success:
      textColor = colors.success700;
      backgroundColor = colors.success50;
      break;
    case EChipsVariants.success100:
      textColor = colors.success900;
      backgroundColor = colors.success100;
      break;
    case EChipsVariants.warning:
      textColor = colors.warning800;
      backgroundColor = colors.warning50;
      break;
    case EChipsVariants.error:
      textColor = colors.error700;
      backgroundColor = colors.error100;
      break;
    default:
      textColor = colors.success600;
      backgroundColor = colors.success50;
  }
  return (
    <StyledWrapper backgroundColor={backgroundColor}>
      <Typography
        variant="overline"
        sx={{
          display: 'flex',
          alignItems: 'center',
          lineHeight: { lineHeight },
          letterSpacing: '0.08em',
          color: textColor,
        }}
      >
        {text}
      </Typography>
    </StyledWrapper>
  );
};
